import {Injectable} from "@angular/core";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {EventBusService} from "../../../base/services/eventbus/event-bus.service";
import {ILeadDetail} from "../../../modules/dash/domains/sales/leads/models/lead.model";
import {SalesEndpoints} from "../../../modules/dash/domains/sales/sales.endpoints";
import {ResponseData} from "../../../base/models/pagination.model";
import {ICampaignLeadReq} from "./campaign-lead.model";
import {BaseService} from "../../../base/services/base.service";
import {NotifierService} from "../../../base/services/notifier/notifier.service";
import {AuthService} from "../../../modules/common/modules/auth/services/auth.service";
import {IAuth} from "../../../modules/common/modules/auth/models/auth.model";

@Injectable({
  providedIn: 'root'
})
export class PreRegistrationService extends BaseService{
  constructor(
    private http: HttpClient,
    private eventBusService: EventBusService,
    notifierService: NotifierService,
    authService: AuthService
  ) {
    super(authService, notifierService);
  }
  preRegister(key: string, endpoint: string, leadReq: ICampaignLeadReq) {
    let url = SalesEndpoints.LEADS.CREATE(endpoint)

    let observable = this.http.post<ResponseData<ILeadDetail>>(url, leadReq)

    observable.subscribe(res => {
      this.eventBusService.publish(key, res.body)
    }, (err: HttpErrorResponse) => {
      this.handleError(err,(auth: IAuth) => {
        this.preRegister(key, endpoint, leadReq)
      }, (err: HttpErrorResponse) => {
        this.eventBusService.publish(this.getErrorKey(key), err)
      })
    })
  }
}
